import { render, staticRenderFns } from "./clickHUAWEI.vue?vue&type=template&id=88f4c238&scoped=true"
import script from "./clickHUAWEI.vue?vue&type=script&lang=js"
export * from "./clickHUAWEI.vue?vue&type=script&lang=js"
import style0 from "./clickHUAWEI.vue?vue&type=style&index=0&id=88f4c238&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88f4c238",
  null
  
)

export default component.exports